
import { useGroupsLoading, useGroupActions, useUsageTracking } from "./hooks";

export const useGroupsData = (navigate: (path: string) => void) => {
  const { groups, products, isLoading, setGroups, setProducts } = useGroupsLoading(navigate);
  
  const {
    showAddGroupForm,
    setShowAddGroupForm,
    editingGroup,
    setEditingGroup,
    handleGroupSaved,
    handleEditGroup,
    handleDeleteGroup,
  } = useGroupActions({ setGroups, setProducts });
  
  const { handleRecordUsage } = useUsageTracking({ 
    groups, 
    products, 
    setProducts 
  });

  return {
    groups,
    products,
    isLoading,
    showAddGroupForm,
    setShowAddGroupForm,
    editingGroup,
    setEditingGroup,
    handleGroupSaved,
    handleEditGroup,
    handleDeleteGroup,
    handleRecordUsage
  };
};

import { getUser } from "@/lib/storage";
